import { Component, Vue } from 'vue-property-decorator';

@Component
export default class OAuthMixin extends Vue {
  beforeCreate() {
    const options = this.$options;

    if (options.oauth) {
      this._oauth = options.oauth;
    } else if (this.$root && this.$root.$oauth) {
      // root oauth
      this._oauth = this.$root.$oauth;
    } else if (options.parent && options.parent.$oauth) {
      // parent oauth
      this._oauth = options.parent.$oauth;
    }
  }
}
